import { render, staticRenderFns } from "./resourceCategoryList.vue?vue&type=template&id=b1993286&scoped=true"
import script from "./resourceCategoryList.vue?vue&type=script&lang=js"
export * from "./resourceCategoryList.vue?vue&type=script&lang=js"
import style0 from "./resourceCategoryList.vue?vue&type=style&index=0&id=b1993286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1993286",
  null
  
)

export default component.exports